import React from "react";

import { ConnectedResultsDesktopDeviceStatusCard } from "./desktop-device-status-card/ConnectedDesktopDeviceStatusCard";
import { ConnectedMobileDeviceStatusCard } from "./mobile-device-status-card/ConnectedMobileDeviceStatusCard";
import { ResultsDeviceStatusCardProps } from "./ResultsDeviceStatusCard.types";

export const ResultsDeviceStatusCard: React.FC<ResultsDeviceStatusCardProps> =
  ({ testResult, deviceName, isMobile, selectedDevice }) => {
    if (isMobile) {
      return (
        <ConnectedMobileDeviceStatusCard
          testResult={testResult}
          deviceName={deviceName}
          selectedDevice={selectedDevice}
        />
      );
    } else {
      return (
        <ConnectedResultsDesktopDeviceStatusCard
          testResult={testResult}
          deviceName={deviceName}
          selectedDevice={selectedDevice}
        />
      );
    }
  };
